import React from 'react';
import styles from './Background.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Background = ({
  background,
  styles,
}) => {
  return (
    <div className={cx('Background')} style={{backgroundImage: `url(${background && background})`, ...styles}}/>
  );
};

export default Background;


// WEBPACK FOOTER //
// ./src/app/intro/components/Background/Background.js